import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import classes from './Party.module.css';

const Party = (props) => {
    const party = props.party;
    const offers = props.offers;
    const offersFooter = props.offersFooter;
    let [textStatus, setTextStatus] = useState("off");
    let [btnText, setBtnText] = useState("Περισσότερες Πληροφορίες");

    useEffect(() => {
        // props.resetFilter();
        window.scrollTo(0, 0);
    });

    function changeStatus(){
        if(textStatus === "off"){
            setTextStatus("on");
            setBtnText("Απόκρυψη Κειμένου");
        }else{
            setTextStatus("off");
            setBtnText("Περισσότερες Πληροφορίες");
        }
    }


    return (
        <div className={classes.Party}>
            <h3 className={classes.PartyHeader}>Party στον πολυχώρο μας</h3>

            <div className={classes.PartyIntro} data-status={textStatus}>
                <div>
                    <p>Πραγματοποιειστε το πάρτι γενεθλίων, της ονομαστικής εορτής στο kidcenterplayground σ έναν ιδιαίτερο και ευρύχωρο χώρο!</p>
                    <p>Διαμόρφωστε το μενού σύμφωνα με τις δικές προτιμήσεις.</p> 
                    <p>Για τους μικρούς μας φίλους έχουμε έναν χώρο ασφαλές, άνετο και καθαρό με baby park, φουσκωτό, τραμπολίνο και παιχνίδοκατασκευη. Χρησιμοποιείστε εντελώς δωρεάν την αίθουσα μουσικοκινητικής με προτζέκτορα, μουσική και φωτορυθμικά.</p>
                    <p>Ελατε να διοργάνωσουμε αξέχαστες στιγμές! </p>
                </div>

                <div className={classes.PartyIntroBtn}>
                    <span onClick={changeStatus}>{btnText}</span>
                </div>
            </div>

            <div className={classes.PartySection}>
                <ul>
                    {party.items.map(item => 
                        <li key={item.id} className={classes.PartyItem}>
                            <div className={classes.PartyItemName}>{item.name}</div>
                            <div className={classes.PartyItemPrice}>{item.price.toFixed(2)}</div>
                            <div className={classes.PartyItemDescription}>{item.description[0]}</div>
                        </li>)
                    }
                    
                    <li key="custom" className={classes.PartyItem}>
                            <div className={classes.PartyItemName}>Custom Menu</div>
                            <div className={classes.PartyItemDescription}>Δημιουργήστε το δικό σας μενού, με επιλογές από τον κατάλογο μας</div>
                    </li>
                </ul> 
            </div>

            <h4 className={classes.PartyOffers}>ΠΡΟΣΦΟΡΕΣ ΓΙΑ ΤΙΣ ΚΑΘΗΜΕΡΙΝΕΣ</h4>

            <div className={classes.PartySection}>
                <ul>
                    {offers.map((item, index) => <li key={index} className={classes.PartyOffer}>{item}</li>)}
                </ul>

                <div className={classes.PartyOffersFooter}>
                    <p>{offersFooter}</p>
                </div>
            </div>


             

            <div className={classes.MenuBtn}>
                <Link to='/Menu'>
                    Τιμοκατάλογος Προϊόντων
                </Link>
            </div>   
        </div>
    )
}

export default Party;